import React from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';

const TextArea = styled('textarea')`
  ${tw`border-accent bg-white rounded-sm px-3 py-4 w-full block tracking-wide h-32`}
  border-width: 1px;
`;

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/TextArea.js